import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { LeadDetailsService } from '../../../services/lead-details.service';
import { ReferralDataService } from '../../../services/referral-data.service';
import { SectionsService } from '../../../services/sections.service';
import { AuthorizationUtility } from '../../../shared/authorization/auth.utility';
import { AllowListAuthStore } from '../../../shared/authorization/allow-list-auth.store';
import { PAGE_CONSTANTS } from '../../../shared/constants/page.constants';
import { STATIC_DATA } from '../../../shared/constants/static-data.constants';
import { SharedDataService } from '../../../shared/services/shared-data-service';
import { ParticipantLeadsListComponent } from '../../participant-leads-list/participant-leads-list.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { EnrollmentListComponentOld } from '../enrollment-list_old/enrollment-list.component';
import { UserService } from '../../../services/user.service';
import { NotificationService } from '../../../shared/services/notification.service';

@Component({
  selector: 'ppl-enrollment-list',
  standalone: true,
  imports: [
    NzIconModule,
    NzButtonModule,
    RouterModule,
    EnrollmentListComponentOld
  ],
  templateUrl: './enrollment-list.component.html',
  styleUrl: './enrollment-list.component.css',
})
export class EnrollmentListComponent extends ParticipantLeadsListComponent {
  override sharedDataKey: string = STATIC_DATA.SHARED_ENROLLMENT_DATA;
  override pageId: string = PAGE_CONSTANTS.ENROLLMENT_DATA_GRID_PAGE;

  constructor(
    router: Router,
    sectionService: SectionsService,
    referralDataService: ReferralDataService,
    sharedDataService: SharedDataService,
    authUtility: AuthorizationUtility,
    userService: UserService,
    private leadDetailsService: LeadDetailsService,
    allowListStore: AllowListAuthStore,
    private notificationService: NotificationService
  ) {
    super(
      router,
      sectionService,
      referralDataService,
      sharedDataService,
      userService,
      authUtility,
      allowListStore
    );
  }

  override onNewLead(): void {
    this.router.navigate(['/referralLogic']);
    this.sectionService.setFlow('providers');
    this.referralDataService.clearReferrralData();
  }

  onNewReferral() {
    this.router.navigate(['/newReferral']);
    this.sectionService.setFlow('providerEnrollment');
    this.userService.setLeadEntry('');
    this.referralDataService.clearReferrralData();
  }

  override rowClicked(rowDetail: any) {
    const program = this.userService.getSelectedProgram();
    this.userService.setLeadEntry('referral');
    this.sectionService.setFlow('referral');
    this.userService.setSelectedLead(rowDetail.referral_participant_id);
    if (rowDetail.application_stage_lkp == 'Copied from Lead') {
      if (this.isReadOnly) {
        this.notificationService.error('View Only', 'Cannot open in-progress applications in view-only mode.');
        return;
      }
      this.leadDetailsService
        .fetchLeadDetailsApi(
          'referral',
          program ? program.program_code : '',
          rowDetail.referral_participant_id
        )
        .subscribe((data: any) => {
          this.referralDataService.setReferralDetails(data.responsedata);
          setTimeout(() => {
            this.router.navigate(['/newReferral']);
          }, 200);
        });
    } else {
      setTimeout(() => {
        this.router.navigate(['/home/referralList/referralDetails/']);
      }, 200);
    }
  }
}
